import {
  JITAI_MESSAGE_LIST_REQUEST,
  JITAI_MESSAGE_LIST_SUCCESS,
  JITAI_MESSAGE_LIST_FAIL,
  JITAI_MESSAGE_LIST_RESET,
  JITAI_MESSAGE_CREATE_REQUEST,
  JITAI_MESSAGE_CREATE_SUCCESS,
  JITAI_MESSAGE_CREATE_FAIL,
  JITAI_MESSAGE_CREATE_RESET,
  JITAI_MESSAGE_UPDATE_REQUEST,
  JITAI_MESSAGE_UPDATE_SUCCESS,
  JITAI_MESSAGE_UPDATE_FAIL,
  JITAI_MESSAGE_UPDATE_RESET,
  JITAI_MESSAGE_DELETE_REQUEST,
  JITAI_MESSAGE_DELETE_SUCCESS,
  JITAI_MESSAGE_DELETE_FAIL,
  JITAI_MESSAGE_DELETE_RESET,
  JITAI_VARIABLE_LIST_REQUEST,
  JITAI_VARIABLE_LIST_SUCCESS,
  JITAI_VARIABLE_LIST_FAIL,
  JITAI_VARIABLE_LIST_RESET,
  JITAI_VARIABLE_CREATE_REQUEST,
  JITAI_VARIABLE_CREATE_SUCCESS,
  JITAI_VARIABLE_CREATE_FAIL,
  JITAI_VARIABLE_CREATE_RESET,
  JITAI_VARIABLE_UPDATE_REQUEST,
  JITAI_VARIABLE_UPDATE_SUCCESS,
  JITAI_VARIABLE_UPDATE_FAIL,
  JITAI_VARIABLE_UPDATE_RESET,
  JITAI_VARIABLE_DELETE_REQUEST,
  JITAI_VARIABLE_DELETE_SUCCESS,
  JITAI_VARIABLE_DELETE_FAIL,
  JITAI_VARIABLE_DELETE_RESET,
  JITAI_DECISION_RULE_LIST_REQUEST,
  JITAI_DECISION_RULE_LIST_SUCCESS,
  JITAI_DECISION_RULE_LIST_FAIL,
  JITAI_DECISION_RULE_LIST_RESET,
  JITAI_DECISION_RULE_CREATE_REQUEST,
  JITAI_DECISION_RULE_CREATE_SUCCESS,
  JITAI_DECISION_RULE_CREATE_FAIL,
  JITAI_DECISION_RULE_CREATE_RESET,
  JITAI_DECISION_RULE_UPDATE_REQUEST,
  JITAI_DECISION_RULE_UPDATE_SUCCESS,
  JITAI_DECISION_RULE_UPDATE_FAIL,
  JITAI_DECISION_RULE_UPDATE_RESET,
  JITAI_DECISION_RULE_DELETE_REQUEST,
  JITAI_DECISION_RULE_DELETE_SUCCESS,
  JITAI_DECISION_RULE_DELETE_FAIL,
  JITAI_DECISION_RULE_DELETE_RESET,
  JITAI_RESP_LIST_REQUEST,
  JITAI_RESP_LIST_SUCCESS,
  JITAI_RESP_LIST_FAIL,
  JITAI_RESP_LIST_RESET,
  JITAI_RESP_CREATE_REQUEST,
  JITAI_RESP_CREATE_SUCCESS,
  JITAI_RESP_CREATE_FAIL,
  JITAI_RESP_CREATE_RESET,
  JITAI_RESP_UPDATE_REQUEST,
  JITAI_RESP_UPDATE_SUCCESS,
  JITAI_RESP_UPDATE_FAIL,
  JITAI_RESP_UPDATE_RESET,
  JITAI_RESP_DELETE_REQUEST,
  JITAI_RESP_DELETE_SUCCESS,
  JITAI_RESP_DELETE_FAIL,
  JITAI_RESP_DELETE_RESET,
  JITAI_SCHEDULED_TASK_LIST_REQUEST,
  JITAI_SCHEDULED_TASK_LIST_SUCCESS,
  JITAI_SCHEDULED_TASK_LIST_FAIL,
  JITAI_SCHEDULED_TASK_LIST_RESET,
  JITAI_RULES_USAGE_REQUEST,
  JITAI_RULES_USAGE_SUCCESS,
  JITAI_RULES_USAGE_FAIL,
  JITAI_RULES_USAGE_RESET,
  JITAI_EVALUATE_REQUEST,
  JITAI_EVALUATE_SUCCESS,
  JITAI_EVALUATE_FAIL,
  JITAI_EVALUATE_RESET,
  JITAI_PARTICIPANT_ACTIVITY_REQUEST,
  JITAI_PARTICIPANT_ACTIVITY_SUCCESS,
  JITAI_PARTICIPANT_ACTIVITY_FAIL,
  JITAI_PARTICIPANT_ACTIVITY_RESET,
} from '../constants/jitaiConstants'

export const jitaiMessageListReducer = (
  state = { jitaiMessages: [] },
  action
) => {
  switch (action.type) {
    case JITAI_MESSAGE_LIST_REQUEST:
      return { loading: true, jitaiMessages: [] }
    case JITAI_MESSAGE_LIST_SUCCESS:
      return {
        loading: false,
        jitaiMessages: action.payload.jitaiMessages,
        success: true,
      }
    case JITAI_MESSAGE_LIST_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_MESSAGE_LIST_RESET:
      return { jitaiMessages: [] }
    default:
      return state
  }
}

export const jitaiMessageCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_MESSAGE_CREATE_REQUEST:
      return { loading: true }
    case JITAI_MESSAGE_CREATE_SUCCESS:
      return { loading: false, success: true, jitaiMessage: action.payload }
    case JITAI_MESSAGE_CREATE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_MESSAGE_CREATE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiMessageUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_MESSAGE_UPDATE_REQUEST:
      return { loading: true }
    case JITAI_MESSAGE_UPDATE_SUCCESS:
      return { loading: false, success: true, jitaiMessage: action.payload }
    case JITAI_MESSAGE_UPDATE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_MESSAGE_UPDATE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiMessageDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_MESSAGE_DELETE_REQUEST:
      return { loading: true }
    case JITAI_MESSAGE_DELETE_SUCCESS:
      return { loading: false, success: true }
    case JITAI_MESSAGE_DELETE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_MESSAGE_DELETE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiVariableListReducer = (
  state = { jitaiVariables: [] },
  action
) => {
  switch (action.type) {
    case JITAI_VARIABLE_LIST_REQUEST:
      return { loading: true, jitaiVariables: [] }
    case JITAI_VARIABLE_LIST_SUCCESS:
      return {
        loading: false,
        jitaiVariables: action.payload.jitaiVariables,
        success: true,
      }
    case JITAI_VARIABLE_LIST_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_VARIABLE_LIST_RESET:
      return { jitaiVariables: [] }
    default:
      return state
  }
}

export const jitaiVariableCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_VARIABLE_CREATE_REQUEST:
      return { loading: true }
    case JITAI_VARIABLE_CREATE_SUCCESS:
      return { loading: false, success: true, jitaiVariable: action.payload }
    case JITAI_VARIABLE_CREATE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_VARIABLE_CREATE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiVariableUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_VARIABLE_UPDATE_REQUEST:
      return { loading: true }
    case JITAI_VARIABLE_UPDATE_SUCCESS:
      return { loading: false, success: true, jitaiVariable: action.payload }
    case JITAI_VARIABLE_UPDATE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_VARIABLE_UPDATE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiVariableDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_VARIABLE_DELETE_REQUEST:
      return { loading: true }
    case JITAI_VARIABLE_DELETE_SUCCESS:
      return { loading: false, success: true }
    case JITAI_VARIABLE_DELETE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_VARIABLE_DELETE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiDecisionRuleListReducer = (
  state = { jitaiDecisionRules: [] },
  action
) => {
  switch (action.type) {
    case JITAI_DECISION_RULE_LIST_REQUEST:
      return { loading: true, jitaiDecisionRules: [] }
    case JITAI_DECISION_RULE_LIST_SUCCESS:
      return {
        loading: false,
        jitaiDecisionRules: action.payload.jitaiDecisionRules,
        success: true,
      }
    case JITAI_DECISION_RULE_LIST_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_DECISION_RULE_LIST_RESET:
      return { jitaiDecisionRules: [] }
    default:
      return state
  }
}

export const jitaiDecisionRuleCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_DECISION_RULE_CREATE_REQUEST:
      return { loading: true }
    case JITAI_DECISION_RULE_CREATE_SUCCESS:
      return { loading: false, success: true, jitaiDecisionRule: action.payload }
    case JITAI_DECISION_RULE_CREATE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_DECISION_RULE_CREATE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiDecisionRuleUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_DECISION_RULE_UPDATE_REQUEST:
      return { loading: true }
    case JITAI_DECISION_RULE_UPDATE_SUCCESS:
      return { loading: false, success: true, jitaiDecisionRule: action.payload }
    case JITAI_DECISION_RULE_UPDATE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_DECISION_RULE_UPDATE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiDecisionRuleDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_DECISION_RULE_DELETE_REQUEST:
      return { loading: true }
    case JITAI_DECISION_RULE_DELETE_SUCCESS:
      return { loading: false, success: true }
    case JITAI_DECISION_RULE_DELETE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_DECISION_RULE_DELETE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiRespListReducer = (
  state = { jitaiResps: [] },
  action
) => {
  switch (action.type) {
    case JITAI_RESP_LIST_REQUEST:
      return { loading: true, jitaiResps: [] }
    case JITAI_RESP_LIST_SUCCESS:
      return {
        loading: false,
        jitaiResps: action.payload.jitaiResps,
        success: true,
      }
    case JITAI_RESP_LIST_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_RESP_LIST_RESET:
      return { jitaiResps: [] }
    default:
      return state
  }
}

export const jitaiRespCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_RESP_CREATE_REQUEST:
      return { loading: true }
    case JITAI_RESP_CREATE_SUCCESS:
      return { loading: false, success: true, jitaiResp: action.payload }
    case JITAI_RESP_CREATE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_RESP_CREATE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiRespUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_RESP_UPDATE_REQUEST:
      return { loading: true }
    case JITAI_RESP_UPDATE_SUCCESS:
      return { loading: false, success: true, jitaiResp: action.payload }
    case JITAI_RESP_UPDATE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_RESP_UPDATE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiRespDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_RESP_DELETE_REQUEST:
      return { loading: true }
    case JITAI_RESP_DELETE_SUCCESS:
      return { loading: false, success: true }
    case JITAI_RESP_DELETE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_RESP_DELETE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiScheduledTaskListReducer = (
  state = { jitaiTasks: [] },
  action
) => {
  switch (action.type) {
    case JITAI_SCHEDULED_TASK_LIST_REQUEST:
      return { loading: true, jitaiTasks: [] }
    case JITAI_SCHEDULED_TASK_LIST_SUCCESS:
      return {
        loading: false,
        jitaiTasks: action.payload.jitaiTasks,
        success: true,
      }
    case JITAI_SCHEDULED_TASK_LIST_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_SCHEDULED_TASK_LIST_RESET:
      return { jitaiTasks: [] }
    default:
      return state
  }
}

export const jitaiRulesUsageReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_RULES_USAGE_REQUEST:
      return { loading: true }
    case JITAI_RULES_USAGE_SUCCESS:
      return { loading: false, success: true, usage: action.payload }
    case JITAI_RULES_USAGE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_RULES_USAGE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiEvaluateReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_EVALUATE_REQUEST:
      return { loading: true }
    case JITAI_EVALUATE_SUCCESS:
      return { loading: false, success: true, evaluateResult: action.payload }
    case JITAI_EVALUATE_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_EVALUATE_RESET:
      return {}
    default:
      return state
  }
}

export const jitaiParticipantActivityReducer = (state = {}, action) => {
  switch (action.type) {
    case JITAI_PARTICIPANT_ACTIVITY_REQUEST:
      return { loading: true }
    case JITAI_PARTICIPANT_ACTIVITY_SUCCESS:
      return { loading: false, success: true, activity: action.payload }
    case JITAI_PARTICIPANT_ACTIVITY_FAIL:
      return { loading: false, error: action.payload }
    case JITAI_PARTICIPANT_ACTIVITY_RESET:
      return {}
    default:
      return state
  }
}